import { useContext } from 'react';
import { TransportSearchContext } from '../contexts/TransportSearchContext';
import { TransportSearchContextInterface } from '../types/TransportSearchContextTypes';

// A custom hook allows us to test better.
export const useTransportSearchContext = () => useContext(TransportSearchContext) as TransportSearchContextInterface;

export default useTransportSearchContext;
